import * as React from 'react';
import { Col } from 'react-bootstrap';
import { Field } from 'redux-form';

import TextField from 'af-fields/Text';
import Textarea from 'af-fields/Textarea';

import Section from '../Shared/Section';

interface OwnProps {
	disabled: boolean;
	resetTimer: () => void;
}

type Props = OwnProps;

const TEXTAREA_ROW_COUNT = 6;
const NOTES_MAX_CHAR_COUNT = 250;

const WorkOrderNotes: React.FC<Props> = (props) => {
	const { disabled, resetTimer } = props;
	return (
		<Section
			label="Notes"
			tooltip="Additional information that field people need to get the work done. WO notes appear on Schedule board, while Job notes contain job-specific information. Field people will see this."
		>
			<Col sm={12}>
				<Field
					component={Textarea}
					disabled={disabled}
					label="Work Order Notes"
					maxCharacters={NOTES_MAX_CHAR_COUNT}
					name="notes"
					onValueChange={resetTimer}
					placeholder="Enter Work Order Notes"
					rows={TEXTAREA_ROW_COUNT}
					showMaxCharactersLabel={true}
				/>
			</Col>
			<Col sm={12}>
				<Field
					component={Textarea}
					disabled={disabled}
					label="Scope of Work"
					name="scopeOfWork"
					onValueChange={resetTimer}
					placeholder="Enter Scope of Work"
					rows={TEXTAREA_ROW_COUNT}
				/>
			</Col>
			<Col sm={12}>
				<Field component={TextField} defaultValue="-" label="Job Notes" name="job.jobNote" />
			</Col>
		</Section>
	);
};

export default React.memo(WorkOrderNotes);
